<script lang="ts" setup>
import { myRequest } from '@/utils/fetch'
import { ref, type Ref } from 'vue'
const regex: Ref<string> = ref('')
const loadingBlacklist = ref(false)
const blacklist: Ref<
  Array<{
    blacklistID: number
    userID: number
    regex: string
  }>
> = ref([])

const addBlacklist = async () => {
  if (!regex.value) return
  loadingBlacklist.value = true
  try {
    blacklist.value = await myRequest('POST', '/user/blacklist', { regex: regex.value })
    regex.value = '' // Clear input after successful add
  } catch (error) {
    console.error('Failed to add blacklist item:', error)
  } finally {
    loadingBlacklist.value = false
  }
}

const getBlacklist = async () => {
  loadingBlacklist.value = true
  try {
    blacklist.value = await myRequest('GET', '/user/blacklist')
  } catch (error) {
    console.error('Failed to get blacklist:', error)
  } finally {
    loadingBlacklist.value = false
  }
}

const removeBlacklist = async (blacklistID: number) => {
  loadingBlacklist.value = true
  try {
    blacklist.value = await myRequest('DELETE', `/user/blacklist/${blacklistID}`)
  } catch (error) {
    console.error('Failed to remove blacklist item:', error)
  } finally {
    loadingBlacklist.value = false
  }
}

getBlacklist()
</script>

<template>
  <div class="myCard q-pt-md">
    <h6 class="text-h6">Who Do You <b>NOT</b> Want to Get Meeting Prep For?</h6>

    <div class="row full-width">
      <q-input
        filled
        label="Enter email or pattern (e.g., *@company.com)"
        dense
        v-model="regex"
        class="q-mr-md col-12 col-md"
      />
      <q-btn
        :disable="loadingBlacklist || !regex"
        @click="addBlacklist"
        :loading="loadingBlacklist"
        label="Add"
        class="col-12 col-md-2"
        color="secondary"
      />
    </div>
    <div class="text-caption text-grey-6 q-mt-md">
      Use * as wildcard. Example: *@domain.com excludes all emails from that domain
    </div>
    <div class="row">
      <q-chip
        v-for="item in blacklist"
        :key="item.blacklistID"
        color="accent"
        removable
        @remove="removeBlacklist(item.blacklistID)"
        ><span class="regex-text">{{ item.regex }}</span></q-chip
      >
    </div>
  </div>
</template>
